import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import ActionModal from 'components/Modal/ActionModal'
import useActions from 'pages/Ran/Actions/use-actions'
import { trackEvent } from 'analytics'

const Reset = () => {
  const { roomId } = useParams()
  const [error, setError] = useState(null)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { reset, processing } = useActions()
  const handleReset = async () => {
    const { error: newError } = await reset({ roomId: parseInt(roomId) })
    setError(newError)
    if (!newError) {
      trackEvent('private_wifi_passphrase_reset', { action_scope: 'item' })
    }
    navigate('..')
  }
  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmColor="primary"
      confirmLabel={t('ui_elements.confirm')}
      description={(
        <Box
          sx={{
            fontSize: 14,
            textAlign: 'center'
          }}
          dangerouslySetInnerHTML={{ __html: t('ran.delete.detail') }}
        />
      )}
      icon={<i className="fa-regular fa-arrow-right-arrow-left" />}
      loading={processing}
      onClose={() => navigate('..')}
      onConfirm={handleReset}
      title={t('ran.reset.title')}
      variant="primary"
    >
      {Boolean(error) && <Typography color={'error'}>{t('ran.actions.error')}</Typography>}
    </ActionModal>
  )
}

export default Reset
